import axios from "axios";
import { encode as base64_encode } from "base-64";
import React from "react";
import { Select, Switch } from "react-materialize";
import HeaderPage from "../../components/PageHeader/PageHeader";
import StepCounter from "../../components/StepCounter/StepCounter";
import "../../index.css";
import { inserirCookie, retornarCookie } from "../../services/cookieservice";
import "./InformacoesComplementaresPage.css";
import Loader from "../../components/Loader/Loader";

const {
  REACT_APP_API,
  REACT_APP_URL_INSTANCE,
  REACT_APP_COMISSAO_MEDICINA_PADRAO,
  REACT_APP_TIPO_CONTRATACAO_PADRAO,
} = process.env;

export default class InformacoesComplementaresPage extends React.Component {
  state = {
    TiposContratacoes: [],
    ListaCoparticipacao: [],
    Oportunidade: undefined,
    TipoContratacao: undefined,
    Coparticipacao: undefined,
    IdFilial: retornarCookie("Filial"),
    exibeCarregamento: false,
  };

  handleChangeSelect = (event) => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  };

  selectForStringRpyGrupo = (array) => {
    const Coparticipacao = array.map((item) => item.rpy_grupo).join(", ");

    this.setState({
      Coparticipacao: Coparticipacao,
    });
  };

  handleChangeSelectListaCoparticipacao = (event) => {
    const selectedValue = event.target.value;

    const filteredList = this.state.ListaCoparticipacao.filter(
      (grupo) => grupo.rpy_grupo === selectedValue
    );

    this.setState({
      ListaCoparticipacao: filteredList,
    });

    this.selectForStringRpyGrupo(filteredList);
  };

  onChange = (event) => {
    const { name } = event.target;
    const value = event.target.checked ? 1 : 0;

    this.setState({
      [name]: value,
    });
  };

  CadastrarInformacoesComplementares = async () => {
    this.setState({ exibeCarregamento: true });

    const urlParams = new URLSearchParams(window.location.search);

    const OportunidadeID = urlParams.get("OportunidadeID");
    const oportunidadeAtual = this.state.Oportunidade || {};
    const oportunidadeIdAtual =
      oportunidadeAtual.OportunidadeID ?? oportunidadeAtual.oportunidadeID ?? OportunidadeID;

    // PUT performs full update in this API; preserve previously loaded fields and only override complement data.
    const payload = {
      ...oportunidadeAtual,
      OportunidadeID: oportunidadeIdAtual,
      OportunidadeId: oportunidadeIdAtual,
      TipoContratacao: "E39FD95B-8143-EE11-8127-00155D014046",
      rpy_modalidade_contratacao: this.state.TipoContratacao,
      Copayfixo: this.state.Coparticipacao,
      IdFilial:
        this.state.IdFilial ?? oportunidadeAtual.IdFilial ?? oportunidadeAtual.idFilial,
    };

    await axios
      .put(
        `${REACT_APP_API}oportunidade?IdAgenteVendas=` +
        retornarCookie("IdAgenteVenda") +
        "&CdAgenteVendas=" +
        retornarCookie("CdAgenteVendas"),
        payload
      )
      .then((res) => {
        this.setState({ exibeCarregamento: false });
      });
  };

  ObterInformacoesProposta = async () => {
    const urlParams = new URLSearchParams(window.location.search);

    axios.defaults.headers.get["Access-Control-Allow-Origin"] = "*";
    await axios
      .get(
        `${REACT_APP_API}oportunidade/OportunidadePorId?oportunidadeID=${urlParams.get(
          "OportunidadeID"
        )}&CdAgenteVendas=${retornarCookie(
          "CdAgenteVendas"
        )}&IdAgenteVendas=${retornarCookie("IdAgenteVenda")}`
      )
      .then((res) => {
        const Oportunidade = res.data;
        this.setState({ Oportunidade });
      });
  };

  componentDidMount() {
    this.ObterInformacoesProposta().then(() => {
      this.setState({ exibeCarregamento: true });
      const urlParams = new URLSearchParams(window.location.search);

      axios.defaults.headers.get["Access-Control-Allow-Origin"] = "*";
      axios.get(`${REACT_APP_API}tipoContratacao`).then((res) => {
        const TiposContratacoes = res.data;
        this.setState({ TiposContratacoes });
      });

      axios
        .get(
          `${REACT_APP_API}Coparticipacao?oportunidadeID=${urlParams.get(
            "OportunidadeID"
          )}&CdAgenteVendas=${retornarCookie("CdAgenteVendas")}`
        )
        .then((res) => {
          const ListaCoparticipacao = res.data;
          this.setState({ ListaCoparticipacao });
          this.setState({ exibeCarregamento: false });
        });

    });
  }

  Continuar = async () => {
    if (this.state.Coparticipacao && this.state.TipoContratacao) {
      await this.CadastrarInformacoesComplementares().then(() => {
        const urlParams = new URLSearchParams(window.location.search);

        const oportunidadeId = urlParams.get("OportunidadeID");

        const redirectTo = base64_encode("NavigationBar,GerarPropostaPage");

        document.location.href = `${REACT_APP_URL_INSTANCE}${redirectTo}&Auth=${base64_encode(
          retornarCookie("Auth")
        )}&OportunidadeID=${oportunidadeId}`;
      });
    }else{
      alert("É necessário escolher ao menos uma modalidade de contratação e coparticipação para prosseguir.");
    }

  };

  render() {
    const passoAtual = () => {
      const nivelRaw =
        this.state.Oportunidade?.NivelOportunidade ?? this.state.Oportunidade?.nivelOportunidade;
      const qtdeVidasRaw = this.state.Oportunidade?.QtdeVidas ?? this.state.Oportunidade?.qtdeVidas;
      const nivel = Number(nivelRaw);
      const qtdeVidas = Number(qtdeVidasRaw);
      const isNivel2 =
        nivel === 2 ||
        (!Number.isNaN(qtdeVidas) && qtdeVidas >= 30 && qtdeVidas <= 99);
      const reembolsoRaw =
        this.state.Oportunidade?.ReembolsoDiferenciado ?? this.state.Oportunidade?.reembolsoDiferenciado;
      const hasReembolso =
        reembolsoRaw === true || reembolsoRaw === 1 || reembolsoRaw === '1' || reembolsoRaw === 'true';

      if (!isNivel2) {
        return <StepCounter step="3" total="4" />;
      }

      return <StepCounter step={hasReembolso ? "5" : "4"} total={hasReembolso ? "6" : "5"} />;
    };

    return (
      <div className="fade-in">
        {this.state.exibeCarregamento && <Loader />}

        <div>
          <div>
            <div className="row container">
              <div className="col s9 m9 l9">
                <br />
                <b>
                  <h5>Nova Oportunidade</h5>
                </b>
              </div>
              <div className="col s3 m3 l3">
                <br />
                {passoAtual()}
              </div>
            </div>
            <div className="row container">
              <HeaderPage
                Spotlight="Informações"
                Title="finais"
                Description="Por último, preencha as informações finais sobre coparticipação e modalidade de contratação."
              />
              <div className="col s5 m5 l5 offset-s3 offset-m3 offset-l3">
                <div className="">
                  <div className="col s12 m12 l12">
                    <Select
                      name="TipoContratacao"
                      id="TipoContratacao"
                      onChange={this.handleChangeSelect}
                      defaultValue="0"
                    >
                      <option value="">Tipos de Contratação</option>
                      {this.state.TiposContratacoes &&
                        this.state.TiposContratacoes.map((Tipo) => (
                          <option value={Tipo.ID}>
                            {Tipo.TipoContratacao}
                          </option>
                        ))}
                    </Select>
                  </div>
                </div>

                <div className="col s12 m12 l12">
                  <Select
                    name="Coparticipacao"
                    id="Coparticipacao"
                    onChange={this.handleChangeSelect}
                    defaultValue="0"
                  >
                    <option value="">Coparticipação</option>
                    {this.state.ListaCoparticipacao.map((grupo) => (
                      <option value={grupo.rpy_grupo}>
                        {grupo.rpy_name}
                      </option>
                    ))}
                  </Select>
                </div>

                <div className="col s12 m12 l12">
                  <br />
                  <button
                    type="button"
                    onClick={this.Continuar}
                    disabled={
                      this.state.mostrarDropsComplementares &&
                      (this.state.TipoContratacao === undefined ||
                        this.state.TipoContratacao === "" ||
                        this.state.TipoContratacao === null)
                    }
                    className="OmintButton right"
                  >
                    <a className="WhiteText">Continuar</a>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
